module.exports = " <div class=von-sidebar-wrapper :class=\"{'left': position == 'left', 'right': position == 'right'}\"> <div class=\"click-block click-block-sidebar\" :class=\"{'click-block-hide': !opened}\" @click=close()></div> <scroller width=260 class=von-sidebar :class=\"{'open': opened}\"> <slot></slot> </scroller> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/services/sidebar/Sidebar.vue
// module id = 249
// module chunks = 0